import React from 'react';
import CaptionComposer from '../../../captioner/components/web/CaptionComposer';
import Captions from '../../../subtitles/components/web/Captions';
import { isCaptioner } from '../../../base/user-role/functions';
/**
 * The caption layer for VRS-layout sessions.
 *
 * Contract note for the static guard in
 * vrs-server/__tests__/captioner-vrs-layout-static.test.js: VRSLayout renders
 * neither <Captions /> nor <CaptionComposer /> (both live inside LargeVideo),
 * so this component must stay mounted for EVERY VRS participant — deaf
 * clients are the primary audience, and the person they talk to may also be
 * publishing as a human captioner. The composer stays captioner-only: other
 * roles can display captions but not author tracks.
 *
 * Keeping these two mounts in a dedicated micro-component lets Conference
 * restructure freely; refactors here are intentional-only because the guard
 * pins exactly one line of concern.
 */
const VrsCaptionTools = () => (React.createElement(React.Fragment, null,
    interfaceConfig.DISABLE_TRANSCRIPTION_SUBTITLES || React.createElement(Captions, null),
    isCaptioner() && React.createElement(CaptionComposer, null)));
export default VrsCaptionTools;
